import Vue from "vue";
import VueRouter from "vue-router";
/* views */
import teacherEvalute from "views/f2f/teacherEvalute"; // 讲师评价
import workingWall from "views/working_wall/working_wall"; // 作业墙
import commentList from "views/working_wall/comment_list";
import commentDetail_workingWall from "views/working_wall/comment_detail";
import workingWallDetail from "views/working_wall/working_wall_detail";
import workingWallVideo from "views/working_wall/working_wall_video"; //
import columnVideoList from "views/column_video/column_video_list"; // 专栏视频列表

import h5 from "views/learning_camp_detail/h5";
import scorm from "views/learning_camp_detail/scorm";
import sub from "./modules/sub";
import search from "./modules/search";
import { wxShare } from "../lib/util";

import Index from "views/Index";
Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Login"),
    meta: {
      title: "登录",
      title_en: "Login",
    },
  },
  {
    path: "/loginMiddlePage",
    name: "loginMiddlePage",
    component: () => import("@/views/login_middle_page"),
  },
  {
    path: "/forgetPassword",
    name: "forgetPassword",
    component: () => import("@/views/forget_password"),
    meta: {
      title: "忘记密码",
      title_en: "Forgot Password",
    },
  },
  {
    path: "/method",
    name: "method",
    component: () => import("@/views/forget_password/method"),
    meta: {
      title: "找回密码",
      title_en: "Forgot Password",
    },
  },
  {
    path: "/",
    redirect: "/main/index",
  },
  {
    path: "/main",
    redirect: "/main/index",
  },
  {
    path: "/main/yuncourse",
    name: "yuncourse",
    component: () => import("@/views/yun/course"),
  },
  {
    path: "/main/index",
    name: "Index",
    component: Index,
    meta: {
      title: "首页",
      title_en: "Index",
      keepAlive: true,
    },
  },
  {
    path: "/main/banner_detail",
    name: "bannerDetail",
    component: () => import("@/views/banner_detail"),
    meta: {
      title: "广告详情",
      title_en: "Ads detail",
    },
  },
  {
    path: "/main/expiring",
    name: "expiring",
    component: () => import("@/views/expiring"),
    meta: {
      title: "到期啦",
      keepAlive: true, // 需要被缓存
      title_en: "Due",
    },
  },
  {
    path: "/main/user",
    name: "UserCenter",
    component: () => import("@/views/usercenter"),
    redirect: "/main/user/agent",
    meta: {
      title: "个人中心",
      title_en: "User Center",
    },
    children: [
      {
        path: "agent",
        name: "userAgent",
        component: () => import("@/views/usercenter/UserCenter"),
        meta: {
          title: "个人中心",
          title_en: "User Center",
        },
      },
      {
        path: "study_list",
        name: "userStudyList",
        component: () => import("@/views/usercenter/studyList"),
        meta: {
          title: "学习轨迹",
          title_en: "Study Trace",
          keepAlive: true,
        },
      },
      {
        path: "statement",
        name: "userStatement",
        component: () => import("@/views/usercenter/statement"),
        meta: {
          title: "查报表",
          title_en: "Study Data",
        },
      },
      {
        path: "integral",
        name: "userIntegral",
        component: () => import("@/views/usercenter/integral"),
        meta: {
          title: "积分",
          title_en: "Score List",
        },
      },
      {
        path: "integration_rule",
        name: "integrationRule",
        component: () => import("@/views/usercenter/integrationRule"),
        meta: {
          title: "积分规则",
          title_en: "Score Rules",
        },
      },
      {
        path: "setting",
        name: "userSet",
        component: () => import("@/views/usercenter/setting"),
        meta: {
          title: "设置",
          title_en: "Setting",
        },
      },
      {
        path: "feedback",
        name: "userFeedback",
        component: () => import("@/views/usercenter/feedback"),
        meta: {
          title: "意见反馈",
          title_en: "Feedback",
        },
      },
      {
        path: "language",
        name: "userLanguage",
        component: () => import("@/views/usercenter/language"),
        meta: {
          title: "语言设置",
          title_en: "Language",
        },
      },
      {
        path: "setAccount",
        name: "setAccount",
        component: () => import("@/views/usercenter/setAccount"),
        meta: {
          title: "账号设置",
          title_en: "Account",
        },
      },
      {
        path: "modifyEmail",
        name: "modifyEmail",
        component: () => import("@/views/usercenter/modifyEmail"),
        meta: {
          title: "修改邮箱",
          title_en: "Change Email",
        },
      },
      {
        path: "modifyPassword",
        name: "modifyPassword",
        component: () => import("@/views/usercenter/modifyPassword"),
        meta: {
          title: "修改密码",
          title_en: "Change Password",
        },
      },
      {
        path: "modifyPhone",
        name: "modifyPhone",
        component: () => import("@/views/usercenter/modifyPhone"),
        meta: {
          title: "修改手机号",
          title_en: "Change Mobile",
        },
      },
    ],
  },
  {
    path: "/obligedPassword",
    component: () => import("@/views/usercenter/modifyPassword"),
    meta: {
      title: "修改密码",
      title_en: "Change Password",
    },
  },
  {
    path: "/main/article",
    name: "article",
    component: () => import("@/views/article/Article"),
    meta: {
      title: "文章",
      title_en: "Article",
    },
  },
  {
    path: "/main/articleDetail",
    name: "articleDetail",
    component: () => import("@/views/article/article_detail"),
    meta: {
      title: "文章详情",
      title_en: "Article Detail",
    },
  },
  {
    path: "/main/studyonline",
    name: "studyonline",
    component: () => import("@/views/studyonline/StudyOnline"),
    meta: {
      title: "",
      title_en: "",
    },
  },
  {
    path: "/main/living",
    name: "livingList",
    component: () => import("@/views/living/list"),
    meta: {
      title: "直播",
      keepAlive: true,
      title_en: "Live",
    },
  },
  {
    path: "/main/livingDetail",
    name: "livingDetail",
    component: () => import("@/views/living/detail"),
    meta: {
      title: "直播",
      title_en: "Live",
    },
  },
  {
    path: "/main/livingRoom",
    name: "livingRoom",
    component: () => import("@/views/living/living"),
    meta: {
      title: "直播",
      title_en: "Live",
    },
  },
  {
    path: "/main/elective_lib",
    name: "courseCentre",
    component: () => import("@/views/course/course_centre"),
    meta: {
      title: "选修库",
      title_en: "Optional Courses",
      keepAlive: true,
    },
  },
  {
    path: "/main/elective_lib/curricula_variable",
    name: "curricula_variable",
    component: () => import("@/views/course/curricula_variable"),
    meta: {
      title: "培训计划",
      title_en: "Training Plan",
    },
  },
  {
    path: "/main/learning_camp_detail",
    name: "learningCamp",
    component: () => import("views/learning_camp_detail/learning_camp_detail"),
    meta: {
      title: "在线课程",
      title_en: "Online Course",
    },
  },
  {
    path: "/main/learning_material",
    name: "learningMaterial",
    component: () => import("views/learning_camp_detail/course_material"),
    meta: {},
  },
  {
    path: "/main/online_learning_material",
    name: "learningMaterial2",
    component: () => import("views/online_course/course_material"),
    meta: {},
  },
  {
    path: "/main/online_course",
    name: "OnlineCourse",
    component: () => import("views/online_course/learning_camp_details"),
    meta: {
      title: "在线课程",
    },
  },
  {
    path: "/main/comment_detail",
    name: "commentDetail",
    component: () => import("views/learning_camp_detail/comment_detail"),
    meta: {
      title: "",
    },
  },
  {
    path: "/main/add_comment",
    name: "addComment",
    component: () => import("views/learning_camp_detail/add_comment"),
    meta: {
      title: "",
    },
  },
  {
    path: "/main/question_detail",
    name: "questionDetail",
    component: () => import("views/learning_camp_detail/question_detail"),
    meta: {
      title: "",
    },
  },
  {
    path: "/main/replay_detail",
    name: "replayDetail",
    component: () => import("@/views/learning_camp_detail/replay_detail"),
    meta: {
      title: "",
    },
  },
  {
    path: "/main/add_question",
    name: "addQuestion",
    component: () => import("@/views/learning_camp_detail/add_question"),
    meta: {
      title: "",
    },
  },
  {
    path: "/main/add_note",
    name: "addNote",
    component: () => import("@/views/learning_camp_detail/add_note"),
    meta: {
      title: "",
    },
  },
  {
    path: "/main/survey",
    name: "survey",
    component: () => import("@/views/survey/survey"),
    meta: {
      // title:"调查问卷"
    },
  },
  {
    path: "/main/dosurvey",
    name: "dosurvey",
    component: () => import("@/views/survey/dosurvey"),
    meta: {
      title: "",
    },
  },
  {
    path: "/main/faceCourse",
    name: "faceCourse",
    component: () => import("@/views/f2f/f2f"),
    meta: {
      title: "面授详情",
      title_en: "In-Classroom Information",
    },
  },
  {
    path: "/main/teacherEvalute",
    name: "teacherEvalute",
    component: teacherEvalute,
    meta: {
      title: "讲师评估",
      title_en: "Evaluate the instructor",
    },
  },
  {
    path: "/main/workingWall",
    name: "workingWall",
    component: workingWall,
    meta: {
      title: "作业墙",
      title_en: "Assignment Display",
      keepAlive: true, // 需要被缓存
    },
  },
  {
    path: "/main/commentList",
    name: "commentList",
    component: commentList,
  },
  {
    path: "/main/commentDetail_workingWall",
    name: " commentDetail_workingWall",
    component: commentDetail_workingWall,
  },
  {
    path: "/main/workingWallDetail",
    name: " workingWallDetail",
    component: workingWallDetail,
    meta: {
      title: "作业详情",
      title_en: "Assignment Detail",
    },
  },
  {
    path: "/main/workingWallVideo",
    name: " workingWallVideo",
    component: workingWallVideo,
  },
  {
    path: "/main/columnVideoList",
    name: "columnVideoList",
    component: columnVideoList,
    meta: {
      title: "专栏视频",
      title_en: "Column Video",
    },
  },
  {
    path: "/main/h5",
    name: "h5",
    component: h5,
  },
  {
    path: "/main/scorm",
    name: "scorm",
    component: scorm,
  },
  {
    path: "/main/other_plantforms",
    name: " otherPlantforms",
    component: () => import("@/views/learning_camp_detail/other_platforms"),
    meta: {
      // title:
    },
  },
  {
    path: "/main/h5_online",
    name: " h5Online",
    component: () => import("@/views/online_course/h5"),
    meta: {
      // title:
    },
  },
  {
    path: "/main/scorm_online",
    name: " scormOnline",
    component: () => import("@/views/online_course/scorm"),
    meta: {
      // title:
    },
  },
  {
    path: "/main/test",
    name: "test",
    component: () => import("@/views/exam"),
    // redirect: 'test/radio',
    meta: {
      title: "小测验",
      title_en: "Quiz",
    },
    children: [
      {
        path: "radio",
        name: "testRadio",
        component: () => import("@/views/exam/radio"),
        meta: {
          title: "小测验",
          title_en: "Quiz",
        },
      },
      {
        path: "check",
        name: "testCheck",
        component: () => import("@/views/exam/check"),
        meta: {
          title: "小测验",
          title_en: "Quiz",
        },
      },
      {
        path: "oneFill",
        name: "testOneFill",
        component: () => import("@/views/exam/one_fill"),
        meta: {
          title: "小测验",
          title_en: "Quiz",
        },
      },
      {
        path: "multiBlanks",
        name: "testMultiBlanks",
        component: () => import("@/views/exam/multi_blanks"),
        meta: {
          title: "小测验",
          title_en: "Quiz",
        },
      },
      {
        path: "judge",
        name: "testJudge",
        component: () => import("@/views/exam/judge"),
        meta: {
          title: "小测验",
          title_en: "Quiz",
        },
      },
      {
        path: "fillIn",
        name: "testFillIn",
        component: () => import("@/views/exam/fill_in"),
        meta: {
          title: "小测验",
          title_en: "Quiz",
        },
      },
      {
        path: "minitest_new",
        name: "minitest_new",
        component: () => import("@/views/exam/minitest_new"),
        meta: {
          title: "小测验",
          title_en: "Quiz",
        },
      },
      {
        path: "otherAnswer",
        name: "testOtherAnswer",
        component: () => import("@/views/exam/other_answer"),
      },
    ],
  },
  {
    path: "/main/test_online",
    name: "testOnline",
    component: () => import("@/views/exam_online"),
    // redirect: 'test/radio',
    meta: {
      title: "小测验",
    },
    children: [
      {
        path: "radio_online",
        name: "testRadioOnline",
        component: () => import("@/views/exam_online/radio"),
        meta: {
          title: "小测验",
        },
      },
      {
        path: "check_online",
        name: "testCheckOnline",
        component: () => import("@/views/exam_online/check"),
        meta: {
          title: "小测验",
        },
      },
      {
        path: "oneFill_online",
        name: "testOneFillOnline",
        component: () => import("@/views/exam_online/one_fill"),
        meta: {
          title: "小测验",
        },
      },
      {
        path: "multiBlanks_online",
        name: "testMultiBlanksOnline",
        component: () => import("@/views/exam_online/multi_blanks"),
        meta: {
          title: "小测验",
        },
      },
      {
        path: "judge_online",
        name: "testJudgeOnline",
        component: () => import("@/views/exam_online/judge"),
        meta: {
          title: "小测验",
        },
      },
      {
        path: "fillIn_online",
        name: "testFillInOnline",
        component: () => import("@/views/exam_online/fill_in"),
        meta: {
          title: "小测验",
        },
      },
      {
        path: "minitest_new_online",
        name: "minitest_newOnline",
        component: () => import("@/views/exam_online/minitest_new"),
        meta: {
          title: "小测验",
        },
      },
      {
        path: "otherAnswer_online",
        name: "testOtherAnswerOnline",
        component: () => import("@/views/exam_online/other_answer"),
      },
    ],
  },
  {
    path: "/main/independent_test",
    name: "IndependentTest",
    component: () => import("@/views/independent_test"),
    meta: {
      title: "独立考试",
      title_en: "Independent Test",
      keepAlive: false,
    },
  },
  {
    path: "/main/independent_online",
    name: "IndependentOnline",
    component: () => import("@/views/independent_online"),
    meta: {
      title: "",
      title_en: "",
      keepAlive: false,
    },
  },
  {
    path: "/main/examResult",
    name: "examResult",
    component: () => import("@/views/independent_test/component/examResult"),
    meta: {
      title: "查看试卷",
      title_en: "View test Questions",
      keepAlive: false,
    },
  },
  {
    path: "/main/examResult_online",
    name: "examResultOline",
    component: () => import("@/views/independent_online/examResult"),
    meta: {
      title: "查看试卷",
      title_en: "View test Questions",
      keepAlive: false,
    },
  },
  {
    path: "/main/test_questions",
    name: "testQuestions",
    component: () => import("@/views/test_questions"),
    meta: {
      title: "独立考试",
      title_en: "Independent Test",
      keepAlive: false,
    },
  },
  {
    path: "/main/test_questions_online",
    name: "testQuestionsOline",
    component: () => import("@/views/independent_online/test_questions"),
    meta: {
      title: "独立考试",
      title_en: "Independent Test",
    },
  },
  {
    path: "/main/submit_success",
    name: "submitSuccess",
    component: () => import("@/views/independent_online/submitSuccess"),
    meta: {
      title: "",
      title_en: "",
    },
  },
  {
    path: "/main/knowledge_exchange",
    name: "knowledgeExchange",
    component: () => import("@/views/knowledge_exchange"),
    redirect: "/main/knowledge_exchange/list",
    children: [
      {
        path: "list",
        name: "knowledgeLIst",
        component: () => import("@/views/knowledge_exchange/list"),
        meta: {
          title: "知识汇",
          title_en: "Content Center",
          keepAlive: true,
        },
      },
      {
        path: "detail",
        name: "knowledgeDetail",
        component: () => import("@/views/knowledge_exchange/detail"),
        meta: {
          title: "知识汇",
          title_en: "Content Center",
        },
      },
      {
        path: "comment",
        name: "knowledgeComment",
        component: () => import("@/views/knowledge_exchange/comment"),
        meta: {
          title: "学员评论",
          title_en: "Students Comments",
        },
      },
      {
        path: "comment_detail",
        name: "knowledgeCommentDetail",
        component: () => import("@/views/knowledge_exchange/comment_detail"),
      },
      {
        path: "write_comment",
        name: "writeComment",
        component: () => import("@/views/knowledge_exchange/write_comment"),
      },
    ],
  },
  {
    path: "/main/collect",
    name: "collect",
    component: () => import("@/views/collect/collect"),
    meta: {
      title: "收藏",
      title_en: "Favorites",
      keepAlive: true, // 需要被缓存
      isBack: true,
    },
  },
  {
    path: "/main/learning_camp",
    name: "learning_camp",
    component: () => import("@/views/learning_camp/learning_camp"),
    meta: {
      title: "学习营",
      title_en: "Study Camp",
      keepAlive: true, // 需要被缓存
      isBack: true,
    },
  },
  {
    path: "/main/project_stage",
    name: "project_stage",
    component: () => import("@/views/project_stage/project_stage"),
    meta: {
      title: "学习项目",
      title_en: "Program",
      keepAlive: true,
    },
  },
  {
    path: "/main/plan_stage",
    name: "plan_stage",
    component: () => import("@/views/project_stage/plan_stage"),
    meta: {
      title: "培训计划",
      title_en: "Training plan",
      keepAlive: true,
    },
  },
  {
    path: "/main/study_stage",
    name: "study_stage",
    component: () => import("@/views/project_stage/study_stage"),
    meta: {
      title: "学习项目",
      title_en: "Program",
      keepAlive: true,
    },
  },
  {
    path: "/main/case",
    name: "case",
    component: () => import("@/views/case/case"),
    meta: {
      title: "案例分析",
      title_en: "Case analysis",
    },
  },
  {
    path: "/main/homework",
    name: "homework",
    component: () => import("@/views/case/homework"),
    meta: {
      title: "作业",
      title_en: "Assignment",
    },
  },
  {
    path: "/main/media_preview",
    name: "media_preview",
    component: () => import("@/views/case/media_preview"),
    meta: {
      // title: '视频预览',
      // title_en:"Video preview",
    },
  },
  {
    path: "/main/media_preview_online",
    name: "media_preview_online",
    component: () => import("@/views/case/media_preview_online"),
    meta: {
      // title: '视频预览'
    },
  },
  {
    path: "/main/file_preview",
    name: "file_preview",
    component: () => import("@/views/case/file_preview"),
    meta: {
      // title: '文档',
      // title_en:"File",
    },
  },
  {
    path: "/main/file_preview_online",
    name: "file_preview_online",
    component: () => import("@/views/case/file_preview_online"),
    meta: {
      // title: '文档'
    },
  },
  {
    path: "/main/text_preview",
    name: "text_preview",
    component: () => import("@/views/case/text_preview"),
    meta: {
      // title: '图文预览',
      // title_en:"Image & text preview",
    },
  },
  {
    path: "/main/text_preview_online",
    name: "text_preview_online",
    component: () => import("@/views/case/text_preview_online"),
    meta: {
      // title: '图文预览'
    },
  },
  {
    path: "/main/reading",
    name: "reading",
    component: () => import("@/views/case/reading"),
    meta: {
      title: "拓展学习",
      title_en: "Extended learning",
    },
  },
  {
    path: "/main/reading_online",
    name: "readingOline",
    component: () => import("@/views/case/reading_online"),
    meta: {
      title: "拓展学习",
      title_en: "Extended learning",
    },
  },
  {
    path: "/main/daka_modal",
    name: "daka_modal",
    component: () => import("@/views/daka/daka_modal"),
    meta: {
      title: "打卡弹窗",
      title_en: "Signing-in pop-up",
    },
  },
  {
    path: "/main/daka_action",
    name: "daka_action",
    component: () => import("@/views/daka/daka_action"),
    meta: {
      title: "行为打卡",
      title_en: "Daily Tracker",
      keepAlive: true, // 需要被缓存
    },
  },
  {
    path: "/main/daka_detail",
    name: "daka_detail",
    component: () => import("@/views/daka/daka_detail"),
    meta: {
      title: "每日行为打卡",
      title_en: "Daily Tracker",
    },
  },
  {
    path: "/main/daka_report",
    name: "daka_report",
    component: () => import("@/views/daka/daka_report"),
    meta: {
      title: "打卡报告",
      title_en: "Signing in report",
    },
  },
  {
    path: "/main/experience_survey",
    name: "experience_survey",
    component: () => import("@/views/experience/experience_survey"),
    meta: {
      title: "体验问卷调查",
      title_en: "Trial questionaire",
    },
  },
  {
    path: "/main/experience_register",
    name: "experience_register",
    component: () => import("@/views/experience/experience_register"),
    meta: {
      keepAlive: true,
      title: "体验注册",
      title_en: "Trial registration",
    },
  },
  {
    path: "/main/experience_register_info",
    name: "experience_register_info",
    component: () => import("@/views/experience/experience_register_info"),
    meta: {
      title: "体验注册信息",
      title_en: "Trial registration info",
    },
  },
  {
    path: "/main/experience_agreement",
    name: "experience_agreement",
    component: () => import("@/views/experience/experience_agreement"),
    meta: {
      title: "服务协议",
      title_en: "Service Protocols",
    },
  },
  {
    path: "/main/experience_agreement2",
    name: "experience_agreement2",
    component: () => import("@/views/experience/experience_agreement2"),
    meta: {
      title: "服务协议",
      title_en: "Service Protocols",
    },
  },
  {
    path: "/main/experience_privacy",
    name: "experiencePrivacy",
    component: () => import("@/views/experience/experience_privacy"),
    meta: {
      title: "隐私政策",
      title_en: "Privacy Policy",
    },
  },
  {
    path: "/main/experience_privacy2",
    name: "experiencePrivacy2",
    component: () => import("@/views/experience/experience_privacy2"),
    meta: {
      title: "隐私政策",
      title_en: "Privacy Policy",
    },
  },
  {
    path: "/main/message",
    name: "message",
    component: () => import("@/views/message/index"),
    meta: {
      title: "消息通",
      title_en: "Message",
      keepAlive: true,
    },
  },
  {
    path: "/main/verstion_hint",
    name: "verstionHint",
    component: () => import("@/views/message/versionChange"),
    meta: {
      title: "升级提示",
      // title_en:'Message',
    },
  },
  {
    path: "/main/message_detail",
    name: "message_detail",
    component: () => import("@/views/message/detail"),
    meta: {
      title: "消息详情",
      title_en: "Information detail",
    },
  },
  {
    path: "/365SMSentry",
    name: "365SMSentry",
    component: () => import("@/views/365course/entranceBridge"),
    meta: {
      title: "",
      title_en: "",
    },
  },
  {
    path: "/learnListToday",
    name: "learnListToday",
    component: () => import("@/views/365course/todayLearnList"),
    meta: {
      title: "",
      title_en: "",
    },
  },
  {
    path: "/nullNotLearned",
    name: "nullNotLearned",
    component: () => import("@/views/365course/nullNotLearned"),
    meta: {
      title: "",
      title_en: "",
    },
  },
  {
    path: "/notLearned",
    name: "notLearned",
    component: () => import("@/views/365course/notLearnedIndex"),
    meta: {
      title: "",
      title_en: "",
      keepAlive: true,
    },
  },
  {
    path: "/searchCourse",
    name: "searchCourse",
    component: () => import("@/views/365course/searchCourse"),
    meta: {
      title: "",
      title_en: "",
      keepAlive: true,
    },
  },
  {
    path: "/main/365course",
    name: "365course",
    component: () => import("@/views/365course"),
    meta: {
      title: "",
      title_en: "",
      keepAlive: true,
    },
  },
  {
    path: "/main/365allAnswer",
    name: "365allAnswer",
    component: () => import("@/views/365course/allAnswer"),
    meta: {
      title: "",
      title_en: "",
    },
  },
  {
    path: "/main/365allPost",
    name: "365allPost",
    component: () => import("@/views/365course/postList"),
    meta: {
      title: "",
      title_en: "",
      keepAlive: true,
    },
  },
  {
    path: "/main/365historyStudy",
    name: "365historyStudy",
    component: () => import("@/views/365course/courseHistory"),
    meta: {
      title: "",
      title_en: "",
    },
  },
  {
    path: "/learnFootprint",
    name: "learnFootprint",
    component: () => import("@/views/365course/footprint"),
    meta: {
      title: "",
      title_en: "",
      keepAlive: true,
    },
  },
  {
    path: "/main/postReply",
    name: "365postReply",
    component: () => import("@/views/365course/postReply"),
    meta: {
      title: "详情",
      title_en: "",
    },
  },
  {
    path: "/main/365AnswerDetail",
    name: "365AnswerDetail",
    component: () => import("@/views/365course/answerDetail"),
    meta: {
      title: "每日一省详情",
      title_en: "",
    },
  },
  {
    path: "/main/365Answer",
    name: "365Answer",
    component: () => import("@/views/365course/submitAnswer"),
    meta: {
      title: "每日一省",
      title_en: "",
    },
  },
  {
    path: "/main/releaseCommunity",
    name: "365community",
    component: () => import("@/views/365course/submitComment"),
    meta: {
      title: "发布到社区",
      title_en: "Publish to community",
    },
  },
  {
    path: "/main/shareFile",
    name: "shareFile",
    component: () => import("@/views/365course/shareFile"),
    meta: {
      title: "",
      title_en: "",
    },
  },
  {
    path: "/main/365Article",
    name: "365Article",
    component: () => import("@/views/365course/article"),
    meta: {
      title: "",
      title_en: "",
    },
  },
  {
    path: "/main/f2fCheckIn",
    name: "f2fCheckIn",
    component: () => import("@/views/f2f/f2fCheckIn"), // 面授签到
    meta: {
      title: "面授签到",
    },
  },
  {
    path: "/main/column_preview",
    name: "column_preview",
    component: () => import("@/views/column_preview/index"),
    meta: {
      title: "专栏预览",
      // title_en:'Information detail',
    },
  },
  {
    path: "/main/error",
    name: "error",
    component: () => import("@/views/online_course/error"), // 面授签到
    meta: {
      title: "",
    },
  },
  {
    path: "/main/jumpPage",
    name: "jumpPage",
    component: () => import("@/views/jumpPage"),
  },
  // {
  //     path: '/main/light2',
  //     name: 'light2',
  //     component: () => import('@/views/free/light2/index'), // 灯塔活动2期
  //     meta: {
  //         title: '中欧商业在线灯塔行动',
  //         keepAlive: true
  //     }
  // },
  // {
  //     path: '/main/light2/choose',
  //     name: 'light2_choose',
  //     component: () => import('@/views/free/light2/choose'), // 灯塔活动2期选择页面
  //     meta: {
  //         title: '中欧商业在线灯塔行动',
  //         keepAlive: true
  //     }
  // },
  {
    path: "/main/report_year_lists",
    name: "report_year_lists",
    component: () => import("@/views/free/year/lists"), // 2020年度学习报告图片列表介绍
    meta: {
      title: "申请体验课程",
      keepAlive: true,
    },
  },
  {
    path: "/main/report_year",
    name: "report_year_company",
    component: () => import("@/views/free/year/company"), // 2020年度学习报告填写公司信息
    meta: {
      title: "申请体验课程",
      keepAlive: true,
    },
  },
  {
    path: "/main/report_year_register_info",
    name: "report_year_register_info",
    component: () => import("@/views/free/year/register_info"), // 2020年度学习报告用户注册信息
    meta: {
      title: "申请体验课程",
      keepAlive: true,
    },
  },
  // {
  //     path: '/main/light2/company',
  //     name: 'light2_company',
  //     component: () => import('@/views/free/light2/company'), // 灯塔活动2期选择企业页面
  //     meta: {
  //         title: '中欧商业在线灯塔行动',
  //         keepAlive: true
  //     }
  // },
  // {
  //     path: '/main/light2/person',
  //     name: 'light2_person',
  //     component: () => import('@/views/free/light2/person'), // 灯塔活动2期选择个人页面
  //     meta: {
  //         title: '中欧商业在线灯塔行动',
  //         keepAlive: true
  //     }
  // },
  // {
  //     path: '/main/light2/wx_code',
  //     name: 'wx_code_person',
  //     component: () => import('@/views/free/light2/wx_code'), // 灯塔活动2期选择个人页面
  //     meta: {
  //         title: '中欧商业在线灯塔行动',
  //         keepAlive: true
  //     }
  // },
  // {
  //     path: '/main/light2/info',
  //     name: 'light2_info',
  //     component: () => import('@/views/free/light2/info'), // 灯塔活动2期选择个人页面
  //     meta: {
  //         title: '中欧商业在线灯塔行动',
  //         keepAlive: true
  //     }
  // },
  {
    path: "/main/free_register",
    name: "free_register",
    component: () => import("@/views/free/free_register"), // 面授签到
    meta: {
      title: "领取免费课程注册页",
      keepAlive: true,
    },
  },
  {
    path: "/main/free_register_info",
    name: "free_register_info",
    component: () => import("@/views/free/free_register_info"),
    meta: {
      title: "领取免费课程信息页",
    },
  },
  {
    path: "/main/user_integral",
    name: "integral_before",
    component: () => import("@/views/usercenter/integralBefore"),
    meta: {
      title: "积分",
      title_en: "Score List",
    },
  },
  {
    path: "/main/user_integral_rule",
    name: "integral_before_rule",
    component: () => import("@/views/usercenter/integralBeforeRule"),
    meta: {
      title: "积分",
      title_en: "Score List",
    },
  },
  {
    path: "/P2Pstudy",
    name: "P2PModule",
    component: () => import("@/views/P2PStudy"),
    redirect: "/P2Pstudy/study_way",
    meta: {
      title: "P2P学习",
    },
    children: [
      {
        path: "study_way",
        name: "P2PstudyWay",
        component: () => import("@/views/P2PStudy/studyWay"),
        meta: {
          keepAlive: true,
          ifDoFresh: false,
        },
      },
      {
        path: "learner",
        name: "P2Plearner",
        component: () => import("@/views/P2PStudy/learner"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "community",
        name: "P2Pcommunity",
        component: () => import("@/views/P2PStudy/community"),
        meta: {
          keepAlive: true,
          ifDoFresh: false,
        },
      },
      {
        path: "footprint",
        name: "P2Pfootprint",
        component: () => import("@/views/P2PStudy/footprint"),
        meta: {
          keepAlive: true,
        },
      },
    ],
  },
  {
    path: "/main/vote",
    name: "P2Pvote",
    component: () => import("@/views/P2Pvote"),
    meta: {
      title: "投票",
      title_en: "",
    },
  },
  {
    path: "/main/openQuestion",
    name: "openQuestion",
    component: () => import("@/views/openQuestion"),
    meta: {
      title: "开放式问题",
      title_en: "",
    },
  },
  {
    path: "/communityPost",
    name: "communityPost",
    component: () => import("@/views/community/submitComment"),
    meta: {
      title: "发帖",
      title_en: "",
    },
  },
  {
    path: "/communityReplay",
    name: "communityReplay",
    component: () => import("@/views/community/postReply"),
    meta: {
      title: "回复",
      title_en: "",
    },
  },
  {
    path: "/dingtalkLogin",
    name: "dingtalkLogin",
    component: () => import("@/views/dingtalkLogin"),
  },
  {
    path: "/weixinLogin",
    name: "weixinLogin",
    component: () => import("@/views/weixinLogin"),
  },
  {
    path: "/weixinLoginTpi",
    name: "weixinLoginTpi",
    component: () => import("@/views/weixinLoginTpi"),
  },
  {
    path: "/weixinMiddle",
    name: "weixinMiddle",
    component: () => import("@/views/weixinMiddle"),
    meta: {
      title: "微信中间页",
    },
  },
  {
    path: "/appMiddle",
    name: "appMiddle",
    component: () => import("@/views/appMiddle"),
    meta: {
      title: "App中间页",
    },
  },
  {
    path: "/noAuth",
    name: "noAuth",
    meta: {
      title: "抱歉，没有权限！",
      title_en: "",
    },
    component: () => import("@/views/no-auth"),
  },
  ...sub,
  ...search,
];

const router = new VueRouter({
  routes,
});

// 如果包含域名字段的文件夹就把此文件夹加入到路由里面
var comName = window.location.origin.split(".")[0].split("//")[1];
var routersInclude = require.context("views/custom_login", true).keys();
if (routersInclude.indexOf("./" + comName + "/login") >= 0) {
  // 包含此域名文件
  router.addRoutes([
    {
      path: "/" + comName,
      name: "custom_login" + comName,
      component: () => import("@/views/custom_login/" + comName + "/login"),
      meta: {
        title: "登陆2",
      },
    },
  ]);
}

router.beforeEach((to, from, next) => {
  if (localStorage.getItem("_user_data_language") == "en-US") {
    // 英文
    document.title = to.meta.title_en ? to.meta.title_en : "\u200E";
  } else {
    // 中文
    document.title = to.meta.title ? to.meta.title : "\u200E";
  }
  if (
    to.name == "Login" &&
    routersInclude.indexOf("./" + comName + "/login") >= 0
  ) {
    next({
      path: "/" + comName,
      replace: true,
    });
  } else {
    next();
  }
});

let ico = location.origin + "/favicon.ico";
router.afterEach((to) => {
  // console.log('to:', to.name)
  if (
    to.name !== "plan_stage" &&
    to.name !== "365historyStudy" &&
    to.name !== "P2PstudyWay" &&
    to.name !== "project_stage" &&
    to.name !== "365course" &&
    to.name !== "learningCamp" &&
    to.name !== "IndependentTest" &&
    to.name !== "reading" &&
    to.name !== "openQuestion" &&
    to.name !== "P2Pvote" &&
    to.name !== "survey" &&
    to.name !== "homework" &&
    to.name !== "case"
  ) {
    wxShare({
      title: document.title,
      desc: location.href,
      link: location.href,
      imgUrl: ico,
    });
  }
});

export default router;
